import React from 'react';
const Header = () => {
    return(
        <header>
            <h1>NEUROMUSE</h1>
            <p style={{paddingBottom:'10px'}}>Let's listen to your mood</p>
        </header>
    );
};
export default Header;